import React from 'react';

class FabeInputText extends React.Component {
    render() {
        return (
            <div className="fabe-input flex flex-wrap">
                <label className="fabe-input__label">{this.props.label}</label>
                <input type={this.props.type || "text"}
                    name={this.props.name} 
                    value={this.props.value} 
                    onChange={this.props.changeHandler} 
                    placeholder={this.props.placeholder} />
                { this.props.errorMessage 
                    ? <label className="fabe-input__label mt-1">{this.props.errorMessage}</label>
                    : '' }
            </div>
        )
    }
}

export default FabeInputText;


// WEBPACK FOOTER //
// ./scripts/components/FabeInputText.jsx